import { useQuery } from "@tanstack/react-query";
import { getDeviceElements } from "../services/deviceService"

export default function useDeviceElements(deviceId) {
  const enabled = Boolean(deviceId);

  const { data = [], isLoading, error } = useQuery(
    ["deviceElements", deviceId], () => getDeviceElements(deviceId),
    {
      enabled,
      staleTime: 0,
      cacheTime: 0,
    }
  );

  return { deviceElements: data, loading: isLoading, error };
}
